<template>
    <div class="flex flex-col mb-8">
        <p class="text-sm font-bold mb-3">
            Звʼязатись з нами: <a class="hover:underline" href="tel:+380730970791">+380 (73) 097-07-91</a>
        </p>
        <p class="text-sm font-bold">
            Email: <a class="hover:underline" href="mailto:cupcult.official@gmail.com">cupcult.official@gmail.com</a>
        </p>
    </div>
    <div class="space-x-6">
        <a class="inline-block text-indigo-500 hover:text-green-500 w-6"
           href="https://instagram.com/cup.cult" target="_blank" aria-label="Instagram" v-html="Instagram"/>
        <a class="inline-block text-indigo-500 hover:text-green-500 w-6"
           href="https://t.me/cupcult_helpbot?start=start" target="_blank" aria-label="Telegram" v-html="Telegram"/>
    </div>
</template>

<script>
import {defineComponent} from 'vue'
import Telegram from '@/Components/Svg/Telegram.svg?raw';
import Instagram from '@/Components/Svg/Instagram.svg?raw';

export default defineComponent({
    setup() {
        return {
            Telegram,
            Instagram
        }
    }
})
</script>
